import { DEFAULT_CHAIN_ID, URUS_CONTRACT } from "../constants";
import { useEthers } from "./useEthers";
import { useTokenAllowance } from "./useTokenAllowance";

export function useUrusAllowance(address: string) {
  const { chainId = DEFAULT_CHAIN_ID } = useEthers();
  const urus = URUS_CONTRACT[chainId];
  return useTokenAllowance(urus, address);
}
